import React from 'react';
import {
  Container,
  Enabled,
  Disabled,
} from '../../../../components/operational-status/styles';
import {
  ALR1_TRP1_BITS,
  ALR2_TRP2_BITS,
  decodeBitmask,
} from '../../../../constants/bluebox';

// Barra de status operacional EQUIVALENTE pra BLUEBOX. O OperationalStatus
// padrao le os bits Sta_* de bomba/UCHA, que a bluebox nao publica — entao
// a barra sumia. Aqui derivamos pares equivalentes das grandezas MQTT da
// bluebox, reusando os mesmos pills (Enabled/Disabled).
//
// Convencao dos pills: Enabled = estado "bom/normal" (esq), Disabled =
// estado critico (dir). Exatamente um lado fica ativo por par.
const BlueboxStatus = ({ data }) => {
  const d = data || {};

  const isToday = (value) => {
    if (!value) return false;
    const parsed = new Date(value);
    if (Number.isNaN(parsed.getTime())) return false;
    const formatter = new Intl.DateTimeFormat('en-CA', {
      timeZone: 'America/Sao_Paulo',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    });
    return formatter.format(parsed) === formatter.format(new Date());
  };

  // Sem dados ainda: nenhum campo relevante presente. Nesse caso deixamos
  // TODOS os pills desativados (nenhum lado aceso) em vez de assumir um
  // estado (ex.: mostrar "SPV falha" so porque o campo veio ausente).
  const RELEVANT_KEYS = [
    'W',
    'Rev',
    'SpvOk',
    'MgeOk',
    'Alr1',
    'Alr2',
    'Trp1',
    'Trp2',
    'Iavg',
    'VLavg',
    'Vsup',
    'Press',
    'FP',
  ];
  const hasData = RELEVANT_KEYS.some((k) => Number.isFinite(Number(d[k])));

  const alarmActive =
    decodeBitmask(d.Alr1, ALR1_TRP1_BITS).length > 0 ||
    decodeBitmask(d.Alr2, ALR2_TRP2_BITS).length > 0;
  const tripActive =
    decodeBitmask(d.Trp1, ALR1_TRP1_BITS).length > 0 ||
    decodeBitmask(d.Trp2, ALR2_TRP2_BITS).length > 0;

  // Regra operacional da Bluebox: tensao de alimentacao maior que zero.
  const supplyVoltage = Number(d.Vsup);
  const running =
    Number.isFinite(supplyVoltage) &&
    supplyVoltage > 0 &&
    isToday(d.dataUpdate);

  const spvOk = Number(d.SpvOk) === 1;
  const mgeOk = Number(d.MgeOk) === 1;

  // Pares equivalentes (esq normal / dir critico). Cada isOn so acende
  // quando ha dados; sem dados => ambos inativos (pill desativado).
  const pairs = [
    {
      left: { label: 'Normal', isOn: hasData && !alarmActive, critical: false },
      right: { label: 'Falha', isOn: hasData && alarmActive, critical: true },
    },
    {
      left: { label: 'Rodando', isOn: hasData && running, critical: false },
      right: { label: 'Parado', isOn: hasData && !running, critical: false },
    },
    {
      left: { label: 'Sem trip', isOn: hasData && !tripActive, critical: false },
      right: { label: 'Trip', isOn: hasData && tripActive, critical: true },
    },
    {
      left: { label: 'SPV OK', isOn: hasData && spvOk, critical: false },
      right: { label: 'SPV falha', isOn: hasData && !spvOk, critical: true },
    },
    {
      left: { label: 'MGE OK', isOn: hasData && mgeOk, critical: false },
      right: { label: 'MGE falha', isOn: hasData && !mgeOk, critical: true },
    },
  ];

  return pairs.map((pair) => (
    <Container key={pair.left.label}>
      <Enabled active={pair.left.isOn} critical={pair.left.critical}>
        {pair.left.label}
      </Enabled>
      <Disabled active={pair.right.isOn} critical={pair.right.critical}>
        {pair.right.label}
      </Disabled>
    </Container>
  ));
};

export default BlueboxStatus;
